import type { UserContextType } from '@/client/context/user'
import { hasUserRole } from '@/client/services/user'

import { AUDITOR_TAGS } from '../tags/constants'
import { SessionTag } from '../tags/types'
import { TutorAuditorLevel } from './types'

export const TUTOR_AUDITOR_LEVEL_TO_AUDITOR_TAGS: Record<TutorAuditorLevel, SessionTag[]> = {
  [TutorAuditorLevel.Flagged]: [],
  // Novice audits will not be visible to tutors, so we're letting the auditors access a tutor's first two sessions. Novice audits are reviewed by coaches.
  [TutorAuditorLevel.Novice]: AUDITOR_TAGS,
  // Beginners cannot access a tutor's first two sessions so that new tutors see high-quality audits.
  [TutorAuditorLevel.Beginner]: AUDITOR_TAGS.filter(tag => tag !== SessionTag.FirstTwoSessions),
  [TutorAuditorLevel.Intermediate]: AUDITOR_TAGS,
  // Only advanced auditors can see flagged 1:1 sessions.
  [TutorAuditorLevel.Advanced]: AUDITOR_TAGS,
}

export function getAuditorTagsUserCanAccess(user: UserContextType): SessionTag[] {
  if (hasUserRole(user, 'admin:mentor') || hasUserRole(user, 'admin:policy')) {
    return AUDITOR_TAGS
  }
  if (user.tutorAuditorLevel == null) {
    return []
  }
  return TUTOR_AUDITOR_LEVEL_TO_AUDITOR_TAGS[user.tutorAuditorLevel]
}
